/**
 * ERD — 테이블 (/adm/dev/erd) — DB 대조·재스캔·AI 설명·schema.sql 내보내기
 * ($j.Pages.Admin.Erd / body data-page-name="Erd")
 *
 * 예전 blade 인라인 스크립트를 로직 그대로 옮겼다. 함수는 모듈 스코프에 두고, DataTables·결과 모달이
 * 그리는 버튼은 onclick 대신 data-erd="동작" 을 달고 initialize() 의 위임 바인딩이 받는다(CLICK 표).
 * 서비스는 app/Services/Erd (README). 마크업·스타일은 adm/pages/dev/erd.blade.php · sass/admin/pages/_erd.scss.
 */

let dtTables = null;
let dtColumns = null;
let dtColSearch = null;
let currentTable = '';
let rightMode = ''; // 'columns' or 'search'
let originMemos = {};
let bizCates = [];
let funcCates = [];
let statusFilter = 'all';   // all | ghost | dead | unclassified

const STATUS_LABEL = {
    active:    ['활성',      'active'],
    ignored:   ['제외',      'ignored'],
    dead:      ['사장후보',  'dead'],
    ghost:     ['유령',      'ghost'],
    reviewed:  ['검토됨',    'reviewed'],
    unscanned: ['미스캔',    'unscanned'],
};

/**
 * 테이블 목록 DataTable
 */
function initTableList() {
    dtTables = new DataTable('#table-tables', {
        autoWidth: false,
        columns: [
            { data: 'name', title: '테이블명', width: '170px',
                render: function (data, type) {
                    if (type !== 'display') return data;
                    const kwd = dtTables ? dtTables.search() : '';
                    return `<span class="tbl-link" data-erd="loadColumns" data-name="${data}">${kwd ? highlightKeyword(data, kwd) : data}</span>`;
                }
            },
            { data: 'memo', title: '설명',
                render: function (data, type, row) {
                    if (type !== 'display') return data;
                    const display = data || '';
                    const id = row.name;
                    const kwd = dtTables ? dtTables.search() : '';
                    const inner = kwd ? highlightKeyword(display, kwd) : display;
                    const cls = 'memo-cell' + (row.memo_auto && display ? ' erd-ai' : '');
                    return `<div class="${cls}" data-id="${id}" data-ca="table" contenteditable="false">${inner}</div>`;
                }
            },
            { data: 'rows', title: '레코드', width: '100px',
                render: function (data) {
                    if (data == null) return '';
                    return Number(data).toLocaleString();
                }
            },
            { data: 'size', title: '용량', width: '110px',
                render: function (data, type, row) {
                    // 표시는 '996.6 MB', 정렬·필터는 원본 바이트.
                    // 안 그러면 문자열 비교라 '16 KB' 가 '996.6 MB' 보다 크게 잡힌다.
                    if (type === 'sort' || type === 'type') return row.size_bytes || 0;
                    return data;
                }
            },
            { data: 'partition', title: '파티션', width: '70px' },
            { data: 'code_refs', title: '참조', width: '70px',
                render: function (data, type, row) {
                    if (type !== 'display') return data;
                    if (data < 0) return '<span class="erd-muted">-</span>';
                    if (data === 0) return '<span class="erd-stale" title="이 저장소 소스에 이름이 없음">0</span>';
                    const paths = (row.code_paths || '').replace(/"/g, '');
                    return `<span title="${paths}">${data}</span>`;
                }
            },
            { data: 'status', title: '상태', width: '80px',
                render: function (data, type) {
                    if (type !== 'display') return data;
                    const [label, cls] = STATUS_LABEL[data] || [data, ''];
                    return `<span class="erd-badge ${cls}">${label}</span>`;
                }
            },
            { data: 'biz_cate', title: '비즈니스', width: '90px',
                render: function (data, type, row) {
                    if (type !== 'display') return data;
                    if (!data) return '';
                    return row.biz_auto ? `<span class="erd-auto" title="자동추정 — 편집하면 고정됩니다">${data}</span>` : data;
                }
            },
            { data: 'func_cate', title: '기능', width: '80px',
                render: function (data, type, row) {
                    if (type !== 'display') return data;
                    if (!data) return '';
                    return row.func_auto ? `<span class="erd-auto" title="자동추정 — 편집하면 고정됩니다">${data}</span>` : data;
                }
            },
            { data: null, title: '', width: '110px', orderable: false, className: 'text-nowrap',
                render: function (data, type, row, meta) {
                    if (row.ignored) {
                        return `<button class="btn btn-default btn-xs" data-erd="toggleIgnore" data-name="${row.name}" data-v="0" title="제외 해제"><i class="fa fa-undo"></i> 되돌리기</button>`;
                    }
                    const revOn = row.reviewed ? ' active' : '';
                    const revTitle = row.reviewed ? '검토완료 해제' : '검토완료 (사장후보에서 내림)';
                    return `<button class="btn btn-default btn-xs" data-erd="openEditModal" data-n="${meta.row}" title="편집"><i class="fa fa-pencil"></i></button>`
                        + ` <button class="btn btn-default btn-xs${revOn}" data-erd="toggleReview" data-name="${row.name}" data-v="${row.reviewed ? 0 : 1}" title="${revTitle}"><i class="fa fa-check"></i></button>`
                        + ` <button class="btn btn-default btn-xs" data-erd="toggleIgnore" data-name="${row.name}" data-v="1" title="제외 — 문서화 대상이 아님. 재스캔해도 다시 안 올라옵니다"><i class="fa fa-ban"></i></button>`;
                }
            },
        ],
        columnDefs: [
            { targets: 2, className: 'text-right' },
            { targets: [3, 4, 5, 6, 7, 8], className: 'text-center' },
        ],
        ajax: {
            url: '/adm/ajax/dev/erd/tables',
            type: 'post',
            dataSrc: function (json) {
                bizCates = json.bizCates || [];
                funcCates = json.funcCates || [];
                renderCounts(json);
                return json.data;
            },
        },
        language: {
            emptyTable: '데이터가 없습니다.',
            zeroRecords: '일치하는 결과가 없습니다.',
            search: '검색:',
            info: '총 _TOTAL_건',
            infoEmpty: '',
            infoFiltered: '(전체 _MAX_건 중)',
        },
        processing: true,
        serverSide: false,
        ordering: true,
        order: [[2, 'desc']],
        pageLength: 20,
        lengthChange: false,
    });

    // 메모 편집 이벤트
    bindMemoEdit('#table-tables');
}

/**
 * 상태 칩 숫자 갱신
 */
function renderCounts(json) {
    const c = json.counts || {};
    const rows = (json.data || []).filter(r => !r.ignored);   // 제외한 표는 어떤 숫자에도 안 넣는다
    $('#cnt-all').text(rows.length);
    $('#cnt-ghost').text(c.ghost || 0);
    $('#cnt-dead').text(c.dead || 0);
    $('#cnt-unclassified').text(c.unclassified || 0);
    $('#cnt-ai').text(rows.filter(r => r.memo_auto || r.biz_auto || r.func_auto).length);
    $('#cnt-ignored').text(c.ignored || 0);

    const scanned = json.scanned_at;
    $('#scan-info').text(scanned ? ('마지막 스캔 ' + scanned) : '스캔 이력 없음 — 전체 재스캔을 먼저 실행하세요');
}

/**
 * 전체 재스캔
 */
function runScan() {
    $.ajax({
        url: '/adm/ajax/dev/erd/scan',
        type: 'POST',
        timeout: 300000,
        beforeSend: function () {
            $j.Ui.Toast.show('스캔 중... (소스 전체를 훑습니다)', { timeout: 300000 });
        },
        success: function (res) {
            $j.Ui.Toast.hide();
            if (res.result !== 'ok') { $j.Common.Util.swalert('스캔 실패'); return; }

            const s = res.summary;
            const addedCols = (s.added_columns || []).reduce((n, i) => n + i.columns.length, 0);
            let html = '<div style="font-size:13px;line-height:1.9;">';
            html += `<div>스캔 파일 <b>${s.scanned_files}</b>개 · 경로 <span class="erd-muted">${(s.roots || []).join(', ')}</span></div>`;
            const newCnt = (s.new_tables || []).length;
            html += `<div>신규 테이블 <b>${newCnt}</b>개 자동등록${newCnt ? ` — ${s.new_tables.slice(0, 5).join(', ')}${newCnt > 5 ? ' 외' : ''}` : ''}</div>`;
            html += `<div>문서에만 남은 유령 테이블 <b class="erd-stale">${(s.ghost_tables || []).length}</b>개</div>`;
            html += `<div>새로 채운 컬럼 <b>${addedCols}</b>개</div>`;
            const goneList = s.deleted_columns || [];
            const goneCols = goneList.reduce((n, i) => n + i.columns.length, 0);
            const goneNames = goneList.flatMap(i => i.columns.map(c => i.table + '.' + c));
            html += `<div>DB 에서 사라진 컬럼 <b class="erd-stale">${goneCols}</b>개 삭제`
                 + (goneCols ? ` — <span class="erd-muted">${goneNames.slice(0, 5).join(', ')}${goneCols > 5 ? ' 외' : ''}</span>` : '')
                 + '</div>';
            html += `<div>자동분류 갱신 <b>${s.auto_classified}</b>개</div>`;
            html += '</div>';
            html += '<div style="text-align:right;margin-top:15px;">'
                 + '<button class="btn btn-default btn-sm" data-erd="close" data-modal="scanResultModal">닫기</button> '
                 + '<button class="btn btn-success btn-sm" data-erd="closeAndRunAi" data-modal="scanResultModal">AI 설명 채우기</button>'
                 + '</div>';

            $j.Ui.JBModal.html('scanResultModal', html, '재스캔 완료');
            dtTables.ajax.reload(null, false);
        },
        error: function () {
            $j.Ui.Toast.hide();
            $j.Common.Util.swalert('스캔 중 오류가 발생했습니다.');
        }
    });
}

/**
 * AI 설명 채우기 — 서버가 한 요청에 3개씩만 처리하므로 남은 게 0 이 될 때까지 반복 호출한다.
 * 189개 × 최대 15초라 한참 걸린다. 중단할 수 있어야 한다.
 */
let aiRunning = false;
let aiStopped = false;
let aiReset = 0;        // 첫 요청에만 실어 시도기록을 초기화한다
let aiTotal = 0;
let aiDoneCount = 0;

function runAi() {
    if (aiRunning) return;

    $.ajax({
        url: '/adm/ajax/dev/erd/ai-pending',
        type: 'POST',
        success: function (res) {
            if (res.result !== 'ok') return;
            if (!res.available) {
                $j.Common.Util.swalert('GEMINI_API_KEY 가 설정되지 않았습니다.\n.env 를 확인해주세요.');
                return;
            }
            let reset = 0;
            if (!res.pending) {
                // 한 번 시도한 테이블은 다시 안 뽑는다. 남은 빈칸은 모델이 '모른다'고 둔 자리다.
                if (!res.blanks) {
                    $j.Ui.Toast.show('채울 빈칸이 없습니다', { type: 'success', timeout: 2000 });
                    return;
                }
                if (!confirm(`아직 빈칸이 남은 테이블이 ${res.blanks}개 있지만 모두 한 번씩 시도한 것입니다.\n(모델이 뜻을 특정하지 못해 비워둔 자리)\n\n시도 기록을 초기화하고 처음부터 다시 돌릴까요?`)) return;
                reset = 1;
            } else {
                if (!confirm(`${res.pending}개 테이블의 빈 설명·분류를 AI 가 채웁니다.\n테이블당 최대 15초, 예상 ${Math.ceil(res.pending * 12 / 60)}분 정도 걸립니다.\n\n계속할까요?`)) return;
            }

            aiRunning = true;
            aiStopped = false;
            aiReset = reset;
            aiTotal = reset ? res.blanks : res.pending;
            aiDoneCount = 0;
            $('#btn-ai').prop('disabled', true);
            $('#ai-log').empty();
            $('#ai-bar').show();
            aiStep();
        }
    });
}

function stopAi() {
    aiStopped = true;
    $('#ai-text').text('현재 묶음까지 끝내고 중단합니다...');
}

function aiStep() {
    $('#ai-text').text(`${aiDoneCount} / ${aiTotal} 처리 중...`);
    $('#ai-fill').css('width', (aiTotal ? Math.round(aiDoneCount * 100 / aiTotal) : 0) + '%');

    $.ajax({
        url: '/adm/ajax/dev/erd/ai-run',
        type: 'POST',
        data: aiReset ? { reset: 1 } : {},
        timeout: 300000,
        success: function (res) {
            aiReset = 0;   // 초기화는 첫 요청 한 번뿐
            if (res.result !== 'ok') {
                aiFinish(res.msg || 'AI 호출 실패');
                return;
            }
            if (!(res.done || []).length) {
                aiFinish(res.msg || '완료');
                return;
            }

            (res.done || []).forEach(function (d) {
                aiDoneCount++;
                let line;
                if (!d.ok) {
                    line = `<b>${d.table}</b> <span class="erd-stale">실패: ${d.error || ''}</span>`;
                } else if (d.skipped) {
                    line = `<b>${d.table}</b> 건너뜀 (빈칸 없음)`;
                } else {
                    const bits = [];
                    if (d.table_memo) bits.push(`설명 "${d.table_memo}"`);
                    if (d.biz_cate)   bits.push(`분류 ${d.biz_cate}`);
                    if (d.func_cate)  bits.push(`기능 ${d.func_cate}`);
                    if (d.columns)    bits.push(`컬럼 ${d.columns}개`);
                    line = `<b>${d.table}</b> ${bits.length ? bits.join(' · ') : '변경 없음'}`;
                }
                $('#ai-log').prepend(`<div>${line}</div>`);
            });

            if (aiStopped || !res.remaining) {
                aiFinish(aiStopped ? '중단했습니다' : '완료');
                return;
            }
            aiStep();
        },
        error: function (xhr, st) {
            aiFinish('통신 오류(' + st + ') — 중단했습니다. 다시 누르면 남은 것부터 이어서 처리합니다.');
        }
    });
}

function aiFinish(msg) {
    aiRunning = false;
    $('#btn-ai').prop('disabled', false);
    $('#ai-text').text(`${msg} (${aiDoneCount} / ${aiTotal})`);
    $('#ai-fill').css('width', '100%');
    dtTables.ajax.reload(null, false);
    if (currentTable) loadColumns(currentTable);
    $j.Ui.Toast.show(msg, { type: 'success', timeout: 2500 });
}

/**
 * 신규/유령 정리 모달
 */
function openDiffModal() {
    $.ajax({
        url: '/adm/ajax/dev/erd/diff',
        type: 'POST',
        beforeSend: function () { $j.Ui.Toast.show('대조 중...', { timeout: 30000 }); },
        success: function (res) {
            $j.Ui.Toast.hide();
            if (res.result !== 'ok') return;

            const news = res.new || [], ghosts = res.ghost || [], colDiff = res.col_diff || [];
            let html = '';

            // ── 신규
            html += `<h4 style="margin:0 0 6px;font-size:14px;">DB 에만 있는 테이블 <b class="erd-stale">${news.length}</b>개</h4>`;
            if (!news.length) {
                html += '<p class="erd-muted" style="font-size:13px;">없습니다.</p>';
            } else {
                html += '<p class="erd-muted" style="font-size:12px;margin:0 0 6px;">분류는 테이블명 규칙으로 추정한 값입니다. 등록 후 편집에서 고칠 수 있습니다.</p>';
                html += '<div class="erd-list"><table><thead><tr>'
                     + '<th style="width:28px;"><input type="checkbox" id="chkAllNew" checked></th>'
                     + '<th>테이블</th><th style="width:80px;">레코드</th><th style="width:80px;">비즈니스</th><th style="width:70px;">기능</th></tr></thead><tbody>';
                news.forEach(function (t) {
                    html += `<tr><td><input type="checkbox" class="chk-new" value="${t.name}" checked></td>`
                         + `<td>${t.name}</td>`
                         + `<td style="text-align:right;">${Number(t.rows).toLocaleString()}</td>`
                         + `<td>${t.biz_cate || '<span class="erd-muted">-</span>'}</td>`
                         + `<td>${t.func_cate || '<span class="erd-muted">-</span>'}</td></tr>`;
                });
                html += '</tbody></table></div>';
                html += '<div style="text-align:right;margin:8px 0 18px;"><button class="btn btn-primary btn-sm" data-erd="registerSelected">선택 등록</button></div>';
            }

            // ── 유령
            html += `<h4 style="margin:14px 0 6px;font-size:14px;">문서에만 남은 테이블 <b class="erd-stale">${ghosts.length}</b>개</h4>`;
            if (!ghosts.length) {
                html += '<p class="erd-muted" style="font-size:13px;">없습니다.</p>';
            } else {
                html += '<p class="erd-muted" style="font-size:12px;margin:0 0 6px;">실제 DB 에서 사라진 테이블입니다. 삭제하면 적어둔 설명도 함께 사라집니다.</p>';
                html += '<div class="erd-list"><table><thead><tr>'
                     + '<th style="width:28px;"><input type="checkbox" id="chkAllGhost"></th>'
                     + '<th>테이블</th><th>설명</th></tr></thead><tbody>';
                ghosts.forEach(function (t) {
                    html += `<tr><td><input type="checkbox" class="chk-ghost" value="${t.name}"></td>`
                         + `<td>${t.name}</td><td class="erd-muted">${t.memo || ''}</td></tr>`;
                });
                html += '</tbody></table></div>';
                html += '<div style="text-align:right;margin:8px 0 18px;"><button class="btn btn-danger btn-sm" data-erd="purgeSelected">선택 문서삭제</button></div>';
            }

            // ── 컬럼 어긋남
            if (colDiff.length) {
                html += `<h4 style="margin:14px 0 6px;font-size:14px;">컬럼이 어긋난 테이블 ${colDiff.length}개</h4>`;
                html += '<p class="erd-muted" style="font-size:12px;margin:0 0 6px;">재스캔이 자동으로 맞춥니다 — 새 컬럼은 채우고, 사라진 컬럼은 설명째 지웁니다.</p>';
                html += '<div class="erd-list"><table><tbody>';
                colDiff.forEach(function (d) {
                    html += `<tr><td style="width:180px;"><b>${d.table}</b></td><td style="font-size:12px;">`;
                    if (d.added.length)   html += `<span style="color:#4a7c3f;">+ ${d.added.join(', ')}</span><br>`;
                    if (d.removed.length) html += `<span class="erd-stale">− ${d.removed.join(', ')}</span>`;
                    html += '</td></tr>';
                });
                html += '</tbody></table></div>';
            }

            $j.Ui.JBModal.html('diffModal', html, '신규 / 유령 정리');

            setTimeout(function () {
                $('#chkAllNew').on('change',   function () { $('.chk-new').prop('checked', this.checked); });
                $('#chkAllGhost').on('change', function () { $('.chk-ghost').prop('checked', this.checked); });
            }, 100);
        },
        error: function () { $j.Ui.Toast.hide(); }
    });
}

function registerSelected() {
    const names = $('.chk-new:checked').map(function () { return this.value; }).get();
    if (!names.length) { $j.Common.Util.swalert('등록할 테이블을 선택해주세요.'); return; }

    $.ajax({
        url: '/adm/ajax/dev/erd/register',
        type: 'POST',
        data: { tables: names },
        timeout: 300000,
        beforeSend: function () { $j.Ui.Toast.show('등록 중...', { timeout: 300000 }); },
        success: function (res) {
            $j.Ui.Toast.hide();
            if (res.result !== 'ok') { $j.Common.Util.swalert(res.msg); return; }
            $j.Ui.JBModal.close('diffModal');
            $j.Ui.Toast.show(res.msg, { type: 'success', timeout: 2500 });
            dtTables.ajax.reload(null, false);
        },
        error: function () { $j.Ui.Toast.hide(); $j.Common.Util.swalert('등록 중 오류가 발생했습니다.'); }
    });
}

function purgeSelected() {
    const names = $('.chk-ghost:checked').map(function () { return this.value; }).get();
    if (!names.length) { $j.Common.Util.swalert('삭제할 테이블을 선택해주세요.'); return; }
    if (!confirm(`${names.length}개 테이블의 ERD 문서를 삭제합니다.\n적어둔 설명도 함께 사라집니다. 계속할까요?`)) return;

    $.ajax({
        url: '/adm/ajax/dev/erd/purge-ghosts',
        type: 'POST',
        data: { tables: names },
        success: function (res) {
            if (res.result !== 'ok') { $j.Common.Util.swalert(res.msg); return; }
            $j.Ui.JBModal.close('diffModal');
            $j.Ui.Toast.show(res.msg, { type: 'success', timeout: 2500 });
            dtTables.ajax.reload(null, false);
        }
    });
}

/**
 * 제외 토글 — '문서화 대상 아님' 판정.
 * 삭제와 다르다: 삭제는 재스캔이 자동등록으로 되살리지만, 제외는 판정이 남아 유지된다.
 */
function toggleIgnore(tableName, ignored) {
    $.ajax({
        url: '/adm/ajax/dev/erd/ignore',
        type: 'POST',
        data: { table_name: tableName, ignored: ignored },
        success: function (res) {
            if (res.result !== 'ok') { $j.Common.Util.swalert(res.msg); return; }
            $j.Ui.Toast.show(res.msg, { type: 'success', timeout: 2000 });

            if (currentTable === tableName && ignored) {
                currentTable = '';
                rightMode = '';
                $('#table-columns').hide();
                $('#erd-right-panel').hide();
                toggleMetaCols(true);
            }
            dtTables.ajax.reload(null, false);
        }
    });
}

/**
 * 소스 미참조 표 일괄 제외 — 등록 시점 자동제외는 앞으로 들어올 표에만 걸리므로,
 * 이미 등록된 것들을 정리할 때 쓴다. 검토완료로 표시한 표는 건드리지 않는다.
 */
function ignoreUnreferenced() {
    $.ajax({
        url: '/adm/ajax/dev/erd/ignore-unreferenced',
        type: 'POST',
        beforeSend: function () { $j.Ui.Toast.show('정리 중...', { timeout: 30000 }); },
        success: function (res) {
            $j.Ui.Toast.hide();
            if (res.result !== 'ok') { $j.Common.Util.swalert(res.msg); return; }
            $j.Ui.Toast.show(res.msg, { type: 'success', timeout: 2500 });
            dtTables.ajax.reload(null, false);
        },
        error: function () { $j.Ui.Toast.hide(); $j.Common.Util.swalert('정리 중 오류가 발생했습니다.'); }
    });
}

/**
 * 검토완료 토글 — 사장후보로 잡혔지만 실제로는 쓰는 테이블을 목록에서 내린다
 */
function toggleReview(tableName, reviewed) {
    $.ajax({
        url: '/adm/ajax/dev/erd/review',
        type: 'POST',
        data: { table_name: tableName, reviewed: reviewed },
        success: function (res) {
            if (res.result !== 'ok') return;
            $j.Ui.Toast.show(reviewed ? '검토완료로 표시했습니다' : '검토완료를 해제했습니다', { type: 'success' });
            dtTables.ajax.reload(null, false);
        }
    });
}

/**
 * .ai/schema.sql 내보내기 — '사용중' 판정 기준
 */
function exportSchema() {
    $.ajax({
        url: '/adm/ajax/dev/erd/export-schema',
        type: 'POST',
        timeout: 300000,
        beforeSend: function () { $j.Ui.Toast.show('내보내는 중...', { timeout: 300000 }); },
        success: function (res) {
            $j.Ui.Toast.hide();
            if (res.result !== 'ok') { $j.Common.Util.swalert(res.msg); return; }

            const added = res.added || [], removed = res.removed || [];
            let html = '<div style="font-size:13px;line-height:1.9;">';
            html += `<div>테이블 <b>${res.tables}</b>개 · ERD 설명을 넣은 컬럼 <b>${res.injected}</b>개</div>`;
            html += `<div class="erd-muted" style="font-size:12px;word-break:break-all;">${res.path}</div>`;
            if (added.length)   html += `<div style="margin-top:8px;color:var(--adm-c-4a7c3f,#4a7c3f);">추가 ${added.length}개 — ${added.join(', ')}</div>`;
            if (removed.length) html += `<div class="erd-stale">빠짐 ${removed.length}개 — ${removed.join(', ')}</div>`;
            if (!added.length && !removed.length) html += '<div class="erd-muted" style="margin-top:8px;">테이블 구성은 이전과 같습니다 (컬럼·설명은 바뀌었을 수 있음).</div>';
            html += '</div>';
            html += '<p class="erd-muted" style="font-size:12px;margin-top:12px;">'
                 + '저장소에 반영하려면 이 파일을 커밋해야 합니다. 운영 서버에서 실행하면 배포 디렉토리에 쓰이므로 다음 배포 때 사라집니다.</p>';
            html += '<div style="text-align:right;margin-top:10px;">'
                 + '<button class="btn btn-default btn-sm" data-erd="close" data-modal="schemaModal">닫기</button></div>';

            $j.Ui.JBModal.html('schemaModal', html, 'schema.sql 내보내기 완료');
        },
        error: function () { $j.Ui.Toast.hide(); $j.Common.Util.swalert('내보내는 중 오류가 발생했습니다.'); }
    });
}

/**
 * 스캔 경로 설정
 */
function openScanRootsModal() {
    $.ajax({
        url: '/adm/ajax/dev/erd/scan-roots',
        type: 'POST',
        success: function (res) {
            const roots = (res.roots || []).join('\n');
            const html = `
                <p style="font-size:12px;" class="erd-muted">
                    프로젝트 루트 기준 상대경로를 한 줄에 하나씩. 비우면 기본값으로 돌아갑니다.<br>
                    다른 저장소가 쓰는 테이블은 '사장후보'로 잘못 잡히므로, 그 저장소 경로를 여기에 추가하세요.
                </p>
                <textarea id="scanRoots" class="form-control" rows="7" style="font-family:monospace;font-size:13px;">${roots}</textarea>
                <div style="text-align:right; margin-top:15px;">
                    <button class="btn btn-default btn-sm" data-erd="close" data-modal="scanRootsModal">취소</button>
                    <button class="btn btn-primary btn-sm" data-erd="saveScanRoots">저장</button>
                </div>
            `;
            $j.Ui.JBModal.html('scanRootsModal', html, '스캔 경로');
        }
    });
}

function saveScanRoots() {
    $.ajax({
        url: '/adm/ajax/dev/erd/scan-roots',
        type: 'POST',
        data: { roots: $('#scanRoots').val() },
        success: function (res) {
            $j.Ui.JBModal.close('scanRootsModal');
            $j.Ui.Toast.show('저장됨 — 전체 재스캔을 실행하면 반영됩니다', { type: 'success', timeout: 2500 });
        }
    });
}

/**
 * 특정 테이블의 컬럼 목록
 */
// 우측 컬럼 패널이 열리면 좌측을 좁힌다 — 레코드·용량·파티션·참조를 접는다.
// 인덱스는 columns 정의 순서와 맞춰야 한다 (0 테이블명 1 설명 2 레코드 3 용량 4 파티션 5 참조 6 상태 …)
function toggleMetaCols(show) {
    [2, 3, 4, 5].forEach(i => dtTables.column(i).visible(show));
}

function loadColumns(tableName) {
    currentTable = tableName;
    rightMode = 'columns';
    toggleMetaCols(false);
    $('#erd-right-panel').show();
    $('#table-col-search').hide();
    $('#table-columns').show();

    if (dtColumns) {
        dtColumns.destroy();
        $('#table-columns').empty();
    }

    dtColumns = new DataTable('#table-columns', {
        autoWidth: false,
        columns: [
            { data: null, title: 'No', width: '40px',
                render: function (data, type, row, meta) {
                    return meta.row + 1;
                }
            },
            { data: 'name', title: '컬럼명', width: '160px',
                render: function (data, type, row) {
                    if (type !== 'display') return data;
                    return Number(row.db_exists) === 0
                        ? `<span class="erd-stale" title="DB 에서 사라진 컬럼">${data}</span>`
                        : data;
                }
            },
            { data: 'memo', title: '설명',
                render: function (data, type, row) {
                    const display = data || '';
                    const id = row.name + '|' + row.ref;
                    const cls = 'memo-cell' + (Number(row.memo_auto) && display ? ' erd-ai' : '');
                    return `<div class="${cls}" data-id="${id}" data-ca="column" contenteditable="false">${display}</div>`;
                }
            },
            { data: 'code_refs', title: '참조', width: '60px',
                render: function (data, type) {
                    if (type !== 'display') return data;
                    const n = Number(data);
                    if (n < 0) return '<span class="erd-muted">-</span>';
                    if (n === 0) return '<span class="erd-stale" title="소스에 이 이름이 없음">0</span>';
                    return n;
                }
            },
        ],
        columnDefs: [
            { targets: [0, 3], className: 'text-center' },
        ],
        ajax: {
            url: '/adm/ajax/dev/erd/columns',
            type: 'post',
            data: { table_name: tableName },
        },
        language: {
            emptyTable: '컬럼이 없습니다.',
            zeroRecords: '일치하는 결과가 없습니다.',
            search: tableName + ' 컬럼 검색:',
            info: '_TOTAL_건',
            infoEmpty: '',
        },
        processing: true,
        serverSide: false,
        ordering: false,
        paging: false,
        searching: true,
    });

    bindMemoEdit('#table-columns');
}

/**
 * 컬럼 검색 결과 (좌측 검색 연동)
 */
function highlightKeyword(text, keyword) {
    if (!text || !keyword) return text || '';
    const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<span style="color:var(--adm-kw-red, red);font-weight:bold;">$1</span>');
}

function loadColSearch(keyword) {
    rightMode = 'search';
    toggleMetaCols(false);
    const kwd = keyword;
    $('#erd-right-panel').show();
    $('#table-columns').hide();
    $('#table-col-search').show();

    if (dtColSearch) {
        dtColSearch.destroy();
        $('#table-col-search').empty();
    }

    dtColSearch = new DataTable('#table-col-search', {
        // 하단 = 좌 건수 · 우 페이지번호 (관리자 표 공통 규약)
        layout: { topStart: null, topEnd: null, bottomStart: 'info', bottomEnd: 'paging' },
        autoWidth: false,
        columns: [
            { data: null, title: 'No', width: '35px',
                render: function (data, type, row, meta) {
                    return meta.row + 1;
                }
            },
            { data: 'ref', title: '테이블', width: '140px',
                render: function (data) {
                    return `<span class="tbl-link" data-erd="loadColumns" data-name="${data}">${data}</span>`;
                }
            },
            { data: 'name', title: '컬럼명', width: '140px',
                render: function (data) {
                    return highlightKeyword(data, kwd);
                }
            },
            { data: 'memo', title: '설명',
                render: function (data, type, row) {
                    const display = data || '';
                    const id = row.name + '|' + row.ref;
                    return `<div class="memo-cell" data-id="${id}" data-ca="column" contenteditable="false">${highlightKeyword(display, kwd)}</div>`;
                }
            },
        ],
        columnDefs: [
            { targets: 0, className: 'text-center' },
        ],
        ajax: {
            url: '/adm/ajax/dev/erd/cols',
            type: 'post',
            data: { search: keyword },
        },
        language: {
            emptyTable: '검색 결과가 없습니다.',
            zeroRecords: '일치하는 결과가 없습니다.',
            info: '컬럼 검색: ' + keyword + ' (_TOTAL_건)',
            infoEmpty: '컬럼 검색: ' + keyword + ' (0건)',
        },
        processing: true,
        serverSide: false,
        ordering: false,
        paging: false,
        searching: false,
    });

    bindMemoEdit('#table-col-search');
}

function hideColSearch() {
    if (rightMode !== 'search') return;
    $('#table-col-search').hide();
    if (currentTable) {
        rightMode = 'columns';
        $('#table-columns').show();
    } else {
        rightMode = '';
        $('#erd-right-panel').hide();
        toggleMetaCols(true);
    }
}

/**
 * 메모 인라인 편집 바인딩
 */
function bindMemoEdit(tableSelector) {
    $(tableSelector).off('click', '.memo-cell').on('click', '.memo-cell', function () {
        const $el = $(this);
        if ($el.attr('contenteditable') === 'true') return;

        const id = $el.data('id');
        originMemos[id] = $el.text();

        $el.attr('contenteditable', 'true').focus();

        $el.one('keypress', function handler(e) {
            if (e.which === 13) {
                e.preventDefault();
                $el.blur();
            }
        });

        $el.one('blur', function () {
            $el.attr('contenteditable', 'false');
            const newText = $el.text().trim();
            if (originMemos[id] !== newText) {
                saveMemo($el.data('id'), newText, $el.data('ca'));
            }
        });
    });
}

/**
 * 분류 select 옵션 생성
 */
function buildCateOptions(list, current) {
    let opts = '<option value="">-</option>';
    list.forEach(v => {
        opts += `<option value="${v}"${v === current ? ' selected' : ''}>${v}</option>`;
    });
    if (current && list.indexOf(current) === -1) {
        opts += `<option value="${current}" selected>${current}</option>`;
    }
    opts += '<option value="__new__">+ 직접입력</option>';
    return opts;
}

/**
 * 테이블 편집 모달
 */
function openEditModal(rowIndex) {
    const row = dtTables.row(rowIndex).data();
    const autoFields = [row.biz_auto ? '비즈니스' : '', row.func_auto ? '기능' : ''].filter(Boolean);
    const autoNote = autoFields.length
        ? `<p class="erd-muted" style="font-size:12px;margin:0 0 8px;"><b>${autoFields.join(' · ')}</b> 분류는 <b>자동추정</b>입니다. 여기서 저장하면 사람이 정한 값으로 고정되어 재스캔이 덮어쓰지 않습니다.</p>`
        : '';
    const html = `
        ${autoNote}
        <div class="form-group">
            <label>테이블명</label>
            <input type="text" class="form-control" value="${row.name}" disabled>
        </div>
        <div class="form-group">
            <label>설명</label>
            <input type="text" id="editMemo" class="form-control" value="${row.memo || ''}">
        </div>
        <div class="form-group">
            <label>비즈니스 분류</label>
            <select id="editBizCate" class="form-control">${buildCateOptions(bizCates, row.biz_cate)}</select>
            <input type="text" id="editBizCateNew" class="form-control" style="display:none; margin-top:5px;" placeholder="새 분류명 입력">
        </div>
        <div class="form-group">
            <label>기능 분류</label>
            <select id="editFuncCate" class="form-control">${buildCateOptions(funcCates, row.func_cate)}</select>
            <input type="text" id="editFuncCateNew" class="form-control" style="display:none; margin-top:5px;" placeholder="새 분류명 입력">
        </div>
        <div style="text-align:right; margin-top:15px;">
            <button class="btn btn-default btn-sm" data-erd="close" data-modal="editTableModal">취소</button>
            <button class="btn btn-primary btn-sm" data-erd="saveEdit" data-name="${row.name}">저장</button>
        </div>
    `;
    $j.Ui.JBModal.html('editTableModal', html, row.name + ' 편집');

    // 직접입력 선택 시 input 표시
    setTimeout(() => {
        $('#editBizCate').on('change', function () {
            $('#editBizCateNew').toggle($(this).val() === '__new__');
            if ($(this).val() === '__new__') $('#editBizCateNew').focus();
        });
        $('#editFuncCate').on('change', function () {
            $('#editFuncCateNew').toggle($(this).val() === '__new__');
            if ($(this).val() === '__new__') $('#editFuncCateNew').focus();
        });
    }, 100);
}

/**
 * 편집 저장
 */
function saveEdit(tableName) {
    const memo = $('#editMemo').val().trim();
    let biz = $('#editBizCate').val();
    let func = $('#editFuncCate').val();

    if (biz === '__new__') biz = $('#editBizCateNew').val().trim();
    if (func === '__new__') func = $('#editFuncCateNew').val().trim();

    // 메모 저장
    $.ajax({
        url: '/adm/ajax/dev/erd/edit',
        type: 'POST',
        data: { ca: 'table', id: tableName, memo: memo }
    });

    // 비즈니스 분류 저장
    $.ajax({
        url: '/adm/ajax/dev/erd/edit-category',
        type: 'POST',
        data: { table_name: tableName, field: 'biz_cate', value: biz }
    });

    // 기능 분류 저장
    $.ajax({
        url: '/adm/ajax/dev/erd/edit-category',
        type: 'POST',
        data: { table_name: tableName, field: 'func_cate', value: func },
        success: function () {
            // 신규 분류값 목록 갱신
            if (biz && bizCates.indexOf(biz) === -1) { bizCates.push(biz); bizCates.sort(); }
            if (func && funcCates.indexOf(func) === -1) { funcCates.push(func); funcCates.sort(); }

            $j.Ui.JBModal.close('editTableModal');
            dtTables.ajax.reload(null, false);
            $j.Ui.Toast.show('저장됨', { type: 'success' });
        }
    });
}

/**
 * 테이블 추가 모달 열기
 */
function openAddTableModal() {
    const html = `
        <div class="form-group">
            <label>테이블명</label>
            <input type="text" id="addTableName" class="form-control" placeholder="예: g5_order">
        </div>
        <div class="form-group">
            <label>비즈니스 분류</label>
            <select id="addBizCate" class="form-control">${buildCateOptions(bizCates, '')}</select>
            <input type="text" id="addBizCateNew" class="form-control" style="display:none; margin-top:5px;" placeholder="새 분류명 입력">
        </div>
        <div class="form-group">
            <label>기능 분류</label>
            <select id="addFuncCate" class="form-control">${buildCateOptions(funcCates, '')}</select>
            <input type="text" id="addFuncCateNew" class="form-control" style="display:none; margin-top:5px;" placeholder="새 분류명 입력">
        </div>
        <p class="text-muted" style="font-size:12px; margin-top:5px;">DB에 존재하는 테이블명을 입력하면 테이블 정보와 컬럼을 자동으로 등록합니다. 분류를 비워두면 테이블명 규칙으로 추정합니다.</p>
        <div style="text-align:right; margin-top:15px;">
            <button class="btn btn-default btn-sm" data-erd="close" data-modal="addTableModal">취소</button>
            <button class="btn btn-primary btn-sm" data-erd="addTable">추가</button>
        </div>
    `;
    $j.Ui.JBModal.html('addTableModal', html, '테이블 추가');
    setTimeout(() => {
        $('#addTableName').focus();
        $('#addBizCate').on('change', function () {
            $('#addBizCateNew').toggle($(this).val() === '__new__');
            if ($(this).val() === '__new__') $('#addBizCateNew').focus();
        });
        $('#addFuncCate').on('change', function () {
            $('#addFuncCateNew').toggle($(this).val() === '__new__');
            if ($(this).val() === '__new__') $('#addFuncCateNew').focus();
        });
    }, 200);
}

/**
 * 테이블 추가
 */
function addTable() {
    const name = $('#addTableName').val().trim();
    if (!name) {
        $j.Common.Util.swalert('테이블명을 입력해주세요.');
        return;
    }
    let biz = $('#addBizCate').val();
    let func = $('#addFuncCate').val();
    if (biz === '__new__') biz = $('#addBizCateNew').val().trim();
    if (func === '__new__') func = $('#addFuncCateNew').val().trim();

    $.ajax({
        url: '/adm/ajax/dev/erd/add-table',
        type: 'POST',
        data: { table_name: name, biz_cate: biz, func_cate: func },
        success: function (res) {
            if (res.result === 'ok') {
                $j.Ui.JBModal.close('addTableModal');
                $j.Ui.Toast.show(res.msg, { type: 'success', timeout: 2000 });
                dtTables.ajax.reload(null, false);
                loadColumns(name);
            } else {
                $j.Common.Util.swalert(res.msg);
            }
        }
    });
}

/*
 * 단건 '삭제'(deleteTable)는 화면에서 뺐다. 재스캔이 자동등록으로 되살리므로 제외 용도로는
 * 쓸 수 없었다 — 그 자리는 toggleIgnore() 가 대신한다. 문서를 실제로 지우는 것은
 * 유령 정리(purgeSelected)뿐이다. 엔드포인트 /delete-table 은 남겨뒀다.
 */

/**
 * 메모 저장 AJAX
 */
function saveMemo(id, text, ca) {
    $.ajax({
        url: '/adm/ajax/dev/erd/edit',
        type: 'POST',
        data: { ca: ca, id: id, memo: text },
        success: function () {
            $j.Ui.Toast.show('저장됨', { type: 'success' });
        }
    });
}

// ── 표·모달이 그리는 버튼의 동작 — data-erd="이름" (+ data-name 테이블명 · data-v 0/1 · data-n 행 · data-modal) ──
const CLICK = {
    loadColumns: (el) => loadColumns(el.dataset.name),
    toggleIgnore: (el) => toggleIgnore(el.dataset.name, Number(el.dataset.v)),
    toggleReview: (el) => toggleReview(el.dataset.name, Number(el.dataset.v)),
    openEditModal: (el) => openEditModal(Number(el.dataset.n)),
    close: (el) => $j.Ui.JBModal.close(el.dataset.modal),
    closeAndRunAi: (el) => { $j.Ui.JBModal.close(el.dataset.modal); runAi(); },
    registerSelected: () => registerSelected(),
    purgeSelected: () => purgeSelected(),
    saveScanRoots: () => saveScanRoots(),
    saveEdit: (el) => saveEdit(el.dataset.name),
    addTable: () => addTable(),
};

export default class Erd {
    initialize() {
        // JS 가 그리는 버튼 — data-erd="동작" 을 위임으로 받는다 (아래 CLICK 표)
        $(document).on('click', '[data-erd]', function (e) {
            const fn = CLICK[this.dataset.erd];
            if (!fn) return;
            if (this.tagName === 'A') e.preventDefault();
            fn(this);
        });

        // blade 마크업에서 옮긴 핸들러 — 상단 도구줄
        $('#btn-ignore-unref').on('click', () => ignoreUnreferenced());
        $('#btnErdScan').on('click', () => runScan());
        $('#btn-ai').on('click', () => runAi());
        $('#btnErdDiff').on('click', () => openDiffModal());
        $('#btnErdExport').on('click', () => exportSchema());
        $('#btnErdAdd').on('click', () => openAddTableModal());
        $('#btnErdStop').on('click', () => stopAi());

        // ── 아래는 예전 blade 인라인에서 최상위로 돌던 것 (순서 그대로) ──
        $(function () {
            initTableList();

            // 모달 내 Enter 키 → 추가
            $(document).on('keypress', '#addTableName', function (e) {
                if (e.which === 13) addTable();
            });

            // 상태 칩 필터
            $(document).on('click', '.erd-chip', function () {
                const f = $(this).data('filter');
                statusFilter = f;
                $('.erd-chip').removeClass('on');
                $(this).addClass('on');
                $('#btn-ignore-unref').prop('hidden', f !== 'dead');   // 사장후보를 볼 때만 일괄 제외를 띄운다
                dtTables.draw();
            });

            // 좌측 검색 시 우측에 컬럼 검색 결과 표시
            let searchTimer = null;
            let lastSearchKwd = '';
            dtTables.on('search.dt', function () {
                const kwd = dtTables.search();
                if (kwd === lastSearchKwd) return;
                lastSearchKwd = kwd;
                clearTimeout(searchTimer);
                searchTimer = setTimeout(function () {
                    // 하이라이트 갱신
                    dtTables.rows().invalidate('data').draw(false);
                    lastSearchKwd = kwd; // draw 후 재진입 방지
                    if (kwd.length >= 2) {
                        loadColSearch(kwd);
                    } else if (kwd.length === 0) {
                        hideColSearch();
                    }
                }, 500);
            });
        });

        /**
         * 상태 칩 필터 — DataTables 전역 검색과 별개로 행을 거른다
         */
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            if (settings.nTable.id !== 'table-tables') return true;

            const row = dtTables.row(dataIndex).data();
            if (!row) return true;

            // 제외한 표는 '제외' 칩으로 봐야만 보인다. '전체' 에도 끼지 않는다 —
            // 여기서 일찍 return 하면 기본 화면에 그대로 남아 제외한 의미가 없다.
            if (statusFilter === 'ignored') return !!row.ignored;
            if (row.ignored) return false;

            if (statusFilter === 'all') return true;
            if (statusFilter === 'unclassified') return !row.biz_cate || !row.func_cate;
            if (statusFilter === 'ai') return !!row.memo_auto || !!row.biz_auto || !!row.func_auto;
            return row.status === statusFilter;
        });
    }
}
